import { useQuery } from "@tanstack/react-query";
import { api } from "../../config";

function useGetPurchaseList(params, enabled) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/purchase`, { params });
            return res.data;
        },
        queryKey: ['purchase-list', params.page, params.limit, params.search, params.createdAtInicio, params.createdAtFim, params.situacao],
        enabled: enabled,
        retry: false,
        refetchOnWindowFocus: false
    })
}

export {
    useGetPurchaseList
}